
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 4.25zM12.13 10A4.84 4.84 0 0014 13.78a4.74 4.74 0 000-7.54A4.84 4.84 0 0012.13 10z"}}),_c('path',{attrs:{"d":"M25 0H3a3 3 0 00-3 3v14a3 3 0 003 3h22a3 3 0 003-3V3a3 3 0 00-3-3zm1 17a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h22a1 1 0 011 1z"}}),_c('path',{attrs:{"d":"M17.63 3.65A6.31 6.31 0 0014 4.79a6.32 6.32 0 010 10.39 6.32 6.32 0 010-10.39 6.24 6.24 0 00-3.63-1.14 6.35 6.35 0 000 12.7A6.24 6.24 0 0014 15.21a6.35 6.35 0 103.63-11.56z"}})])
          )
        }
      }
    